<template>
  <Complete></Complete>
</template>

<script>
export default {
  name: 'RequestPasswordResetComplete',
  components: {
    Complete: () => import('../../components/cloud/ReqPassReset/Complete.vue')
  },
  props: {
    req: Object
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'request-password-reset' && vm.req.editState === 'checked') {
        next();
      } else {
        next({ name: 'request-password-reset' });
      }
    })
  }
}
</script>

<style scoped>
</style>